import { ApiState, defaultApiState } from '@/store/types/general.types';
import { PendingCitationResponse } from '@/api/pending-citations.api';

export interface PendingCitationsState {
  apiState: {
    getPendingCitations: ApiState;
    addPendingCitation: ApiState;
    updatePendingCitation: ApiState;
    archivePendingCitation: ApiState;
    deletePendingCitation: ApiState;
    importPendingCitations: ApiState;
  };
  citationsByDocumentId: Record<number, PendingCitationResponse[]>;
  // Reactivity trigger - updated whenever citations change
  lastUpdated: number;
}

export const initialState: PendingCitationsState = {
  apiState: {
    getPendingCitations: defaultApiState,
    addPendingCitation: defaultApiState,
    updatePendingCitation: defaultApiState,
    archivePendingCitation: defaultApiState,
    deletePendingCitation: defaultApiState,
    importPendingCitations: defaultApiState
  },
  citationsByDocumentId: {},
  lastUpdated: 0
};
